import React, { ReactNode } from 'react';
import { Transform, convertNodeToElement } from 'react-html-parser';
import Tooltip from '../components/Tooltip';
import { transformLink } from './transform';

function makeTooltipId(): string {
  return `_${Math.random().toString(36).substring(2, 11)}`;
}

export function transformToolTip(node: Parameters<Transform>[0], index: number, originalTransform: Transform) {
  if (node.type === 'tag' && node.attribs && node.attribs['data-tooltip'] === '') {
    const tooltipId = makeTooltipId();
    node.attribs.id = tooltipId;
    if (node.name === 'span' && node.attribs.title && node.children && node.children[0]?.data) {
      /* old span tooltip that looks like this
        <span data-tooltip="" title="<p>tooltip content</p>">Text</span>
      */
      return (
        <Tooltip key={tooltipId} value={node.children[0].data} tooltip={node.attribs.title} tooltipId={tooltipId} />
      );
    }
    if (node.name === 'a') {
      /* new style anchor tag tooltip link that looks like this:
        <a data-tooltip>
          <div data-tooltip-content="">
            <p><a href="https://example.com">tooltip content</a></p>
          </div>
          <div data-content="">hello,world</div>
        </a>
      */
      let tooltipHtml: ReactNode = null;
      let content: string = '';
      node.children?.forEach((child: any) => {
        if (child.type === 'tag' && child.attribs && child.attribs['data-tooltip-content'] != null) {
          child.attribs.id = tooltipId;
          tooltipHtml = convertNodeToElement(child, index, originalTransform);
        }
        if (child.type === 'tag' && child.attribs && child.attribs['data-content'] != null) {
          content = (child.children && child.children[0]?.data) || '';
        }
      });
      return <Tooltip key={tooltipId} value={content} tooltip={tooltipHtml} tooltipId={tooltipId} />;
    }
  }
  return undefined;
}

export const transform = (intl: any) => (node: any, index: number) =>
  transformLink(intl)(node) || transformToolTip(node, index, transform(intl));
